import Api from '@/services/Index';


const addAppointment = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/psychologist/appointments', formData);
}

const updateAppointment = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/psychologist/appointments/'+id, formData);
}

const getAllAppointment = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/psychologist/appointments', config);
}

const deleteAppointment = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/psychologist/appointments/'+id);
}

const storeApplication = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/pdrm/applications', formData);
}

const updateApplication = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/pdrm/applications/'+id, formData);
}

const getPsychologists = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/psychologist/appointments/psychologists')
}

const getAllPcgcApplications = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/pdrm/applications', config);
}

const cancelApplication = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/pdrm/applications/'+id);
}

const getPcgcApplication = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/pdrm/applications/'+id);
}

const approveAppointment = async (formData, id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/psychologist/appointments/'+id+'/approve', formData);
}

const getAllPcgcStudentApplications = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/pdrm/applications/student', config);
}

const cancelStudentApplication = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/pdrm/applications/student/'+id);
}


export default {
    addAppointment,
    updateAppointment,
    getAllAppointment,
    deleteAppointment,
    storeApplication,
    updateApplication,
    getPsychologists,
    getAllPcgcApplications,
    cancelApplication,
    getPcgcApplication,
    approveAppointment,
    getAllPcgcStudentApplications,
    cancelStudentApplication
}
